import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Phone } from "lucide-react";
import { Wordmark } from "./SeedMark";

const links = [
  { label: "Imóveis", href: "#imoveis", testId: "nav-imoveis" },
  { label: "Sobre", href: "#sobre", testId: "nav-sobre" },
  { label: "Serviços", href: "#servicos", testId: "nav-servicos" },
  { label: "Contato", href: "#contato", testId: "nav-contato" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (e, href) => {
    e.preventDefault();
    if (location.pathname !== "/") {
      navigate(href === "#top" ? "/" : `/${href}`);
    } else {
      window.__lenis?.scrollTo(href === "#top" ? 0 : href, { offset: href === "#top" ? 0 : -80 });
    }
  };

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1], delay: 0.1 }}
      className={`fixed top-0 left-0 right-0 z-50 transition-[background-color,box-shadow,backdrop-filter] duration-500 ${
        scrolled ? "bg-white/70 backdrop-blur-md shadow-[0_1px_0_rgba(0,76,63,0.08)]" : "bg-transparent"
      }`}
      data-testid="navbar"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 lg:px-10">
        <a href="#top" onClick={(e) => go(e, "#top")} aria-label="Seed Imóveis" data-testid="nav-logo">
          <Wordmark size={30} />
        </a>
        <nav className="hidden items-center gap-8 md:flex">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={(e) => go(e, l.href)}
              data-testid={l.testId}
              className="text-sm font-semibold text-seed-deep/80 transition-colors duration-300 hover:text-seed-salad"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <a
          href="https://wa.me/5534999236969?text=Ol%C3%A1!%20Quero%20falar%20com%20a%20Seed%20Im%C3%B3veis."
          target="_blank"
          rel="noopener noreferrer"
          data-testid="nav-whatsapp-cta"
          className="group flex items-center gap-2 rounded-full bg-seed-vivid px-5 py-2.5 text-sm font-bold text-seed-deep transition-transform duration-300 hover:scale-105"
        >
          <Phone size={15} strokeWidth={2.5} />
          <span className="hidden sm:inline">34 99923-6969</span>
          <span className="sm:hidden">Ligar</span>
        </a>
      </div>
    </motion.header>
  );
};
